const getZipCodePreviewStorageKey = (basketId) => `zipCodePreview:${basketId}`

export const getStoredZipCodePreview = (basketId) => {
    if (!basketId || typeof window === 'undefined') {
        return ''
    }

    try {
        return window.sessionStorage.getItem(getZipCodePreviewStorageKey(basketId)) || ''
    } catch (e) {
        return ''
    }
}

export const setStoredZipCodePreview = (basketId, code) => {
    if (!basketId || typeof window === 'undefined') {
        return
    }

    try {
        window.sessionStorage.setItem(getZipCodePreviewStorageKey(basketId), code)
    } catch (e) {}
}

export const removeStoredZipCodePreview = (basketId) => {
    if (!basketId || typeof window === 'undefined') {
        return
    }

    try {
        window.sessionStorage.removeItem(getZipCodePreviewStorageKey(basketId))
    } catch (e) {}
}
